
import React, { Component } from 'react';
import { InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button,Select } from 'antd';
import PubSub from 'pubsub-js'
import './energyManagePage.less';
import build from "../../../imgs/item/build.png";
import energy from "../../../imgs/item/energy.png";
import schedule from "../../../imgs/item/schedule.png";
import arrow_right from "../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../imgs/btn/arrow_down.png";
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import { changeEnergySelectBuilding } from '../../../utils/net/netUtils';
import { getBuildingArr } from '../../../utils/meshUtils';
import { SPIN_DIALOG_HIDE, SPIN_DIALOG_SHOW } from '../../../const/infoConst';


export default class EnergyManagePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //切换building
            building_arr: [],
            building_select: "",
            //切换数据
            is_down:true, //默认展开
            data_item:0,  //0-area  1-group  2-device  3-log
        };
    }
    //
    componentDidMount() {
        // 刷新UI
        this.updatePageUI();
        PubSub.subscribe('changeEnergyMeshUpdateUI', (msg, data) => {
            this.updatePageUI();
        })
    }


    //刷新UI
    updatePageUI() {
        let name=SPGet("energy_SelectBuildingName");
        this.setState({
            building_arr: getBuildingArr(),
            building_select: name,
        });;
    }
    //切换building下拉菜单
    handleBuildingChange = (value) => {
        let name = getBuildingArr()[value].label;
        meshLog('building', value, name);
        if (name == SPGet("energy_SelectBuildingName")) return;
        this.setState({
            building_select: name,
        });
        changeEnergySelectBuilding(name, "");
    };

    //切换数据
    energyDataArrowClick(){
        let mm=this.state.is_down;
        this.setState({
            is_down: !mm,
        });
    }
    energyDataItemClick(num){
        this.setState({
            data_item: num,
        });
        this.props.onDataToParent(num);
        PubSub.publish("energyDataType", num+"");  //0-area  1-group  2-device  3-log 

        // PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    }



    render() {
        const { is_down, data_item} = this.state;
        return (
            <div className="energy-manage-container">
                {/* Area Management */}
                <div className="energy_header">
                    <span>Data Management</span>
                    {/* <InfoCircleOutlined className="header-icon" /> */}
                </div>


                {/* 模拟计量_切换building */}
                <div className="build_top_title1">
                    <img className='icon' src={build} />
                    <span>Select Building</span>
                </div>
                <Select
                    className="energy_dropdown_build"
                    value={this.state.building_select}
                    onChange={this.handleBuildingChange}
                    options={this.state.building_arr}
                />

                {/* 切换数据 area、groups、devices */}
                <div className="build_top_title2" onClick={() => { this.energyDataArrowClick() }}>
                    <img className='icon' src={energy} />
                    <span>Energy Data</span>
                    <img className='arrow' src={is_down?arrow_down:arrow_right}/>
                </div>
                <div className="data_type_list" style={{ display: is_down?"flex":"none" }}>
                    <span className='item1' style={{backgroundColor:data_item==0?"#0B47BE30":"#ffffff",color:data_item==0?"#0B47BE":"#212121"}} 
                        onClick={() => { this.energyDataItemClick(0) }}>Area</span>
                    <span className='item2' style={{backgroundColor:data_item==1?"#0B47BE30":"#ffffff",color:data_item==1?"#0B47BE":"#212121"}} 
                        onClick={() => { this.energyDataItemClick(1) }}>Group</span>
                    <span className='item3' style={{backgroundColor:data_item==2?"#0B47BE30":"#ffffff",color:data_item==2?"#0B47BE":"#212121"}} 
                        onClick={() => { this.energyDataItemClick(2) }}>Device</span>
                </div>

                {/* Emergency Log */}
                <div className="build_top_title3" onClick={() => { this.energyDataItemClick(3) }}>
                    <img className='icon' src={schedule} />
                    <span>Emergency Log</span>
                    <img className='arrow' src={arrow_right}/>
                </div>

            </div>
        );
    }
}
